import { render, staticRenderFns } from "./AddCustomerTemplate.vue?vue&type=template&id=db912ca4&scoped=true"
import script from "./AddCustomerTemplate.vue?vue&type=script&lang=js"
export * from "./AddCustomerTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerTemplate.vue?vue&type=style&index=0&id=db912ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db912ca4",
  null
  
)

export default component.exports